"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInboundAddressDataForChain = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const thorService_1 = require("./thorService");
const getInboundAddressDataForChain = async (daemonUrl, assetId) => {
    if (!assetId)
        return undefined;
    const assetPoolId = caip_1.adapters.assetIdToPoolAssetId({ assetId });
    const assetChainSymbol = assetPoolId === null || assetPoolId === void 0 ? void 0 : assetPoolId.slice(0, assetPoolId.indexOf('.'));
    const { data: inboundAddresses } = await thorService_1.thorService.get(`${daemonUrl}/lcd/thorchain/inbound_addresses`);
    const activeInboundAddresses = inboundAddresses.filter((a) => !a.halted);
    return activeInboundAddresses.find((inbound) => inbound.chain === assetChainSymbol);
};
exports.getInboundAddressDataForChain = getInboundAddressDataForChain;
